import React, { useEffect, useRef } from 'react';
import lottie from 'lottie-web';

import './index.scss';

const SplashScreen = () => {
  const horseRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = horseRef.current;

    if (!container) {
      return undefined;
    }

    const animation = lottie.loadAnimation({
      container,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: '/splash-screen-horse.json',
    });

    return () => {
      animation.destroy();
    };
  }, []);

  return (
    <div className="SplashScreen-container" data-testid="splash-screen">
      <img
        src="/logo-PMU-infocentre.svg"
        alt="Infocentre Logo"
        title="Infocentre"
        width="280"
        height="auto"
      />
      <div ref={horseRef} className="SplashScreen-container-horse" />
    </div>
  );
};

export { SplashScreen };
